import React from "react"
import { HCF, HUtils } from "@macashipo/mlib"
import BaseNumeral from "./numeral"
import HelperMore from "./_helperMore"
import { KConfigApp } from "src/helpers/K"
const BaseText = props => {
  const more = HUtils.runFuntion(props.fnList, "getMore", [])
  const isNumeral = HelperMore.getIsNumeral(more)
  if (isNumeral === true) {
    return BaseNumeral(props)
  }
  let _moreProps = {}
  if (HCF.getCF(KConfigApp.showDataField) == true) {
    if (props.fieldName) {
      _moreProps["data-field"] = props.fieldName
    }
  }
  return (
    <input
      type={HelperMore.getInputType(more, props.inputType || "text")}
      // value={props.value}//hide because show on ui
      {...HelperMore.getPropsValues(props, { defaultValueWhenNull: "" })}
      onChange={ev => {
        props.onChange && props.onChange(ev.currentTarget.value)
      }}
      className={props.className}
      style={props.style}
      // onInvalid={e => {
      //   // e.target.setCustomValidity("No no no no")//set custom valid default
      //   //disabled check required default
      //   // e.preventDefault()
      // }}
      {...props.attrs}
      // autoComplete="new-password"
      {..._moreProps}
    />
  )
}

export default BaseText
